import { RespostaCliente } from "../../types/cliente/feedback/feedback";
import styles from './styles.module.scss';

type RatingScaleProps = {
    value?: RespostaCliente;
    onChange: (value: RespostaCliente) => void;
};

const OPCOES_AVALIACAO = [
    { valor: RespostaCliente.MUITO_INSATISFEITO, label: 'Muito insatisfeito' },
    { valor: RespostaCliente.INSATISFEITO, label: 'Insatisfeito' },
    { valor: RespostaCliente.NEUTRO, label: 'Neutro' },
    { valor: RespostaCliente.SATISFEITO, label: 'Satisfeito' },
    { valor: RespostaCliente.MUITO_SATISFEITO, label: 'Muito satisfeito' },
];

export function RatingScale({ value, onChange }: RatingScaleProps) {
    return (
        <div className={styles.container}>
            {OPCOES_AVALIACAO.map((opcao, index) => (
                <button
                    key={opcao.valor}
                    type="button"
                    className={`${styles.card} ${value === opcao.valor ? styles.selecionado : ''
                        }`}
                    onClick={() => onChange(opcao.valor)}
                >
                    <div className={styles.numero}>{index + 1}</div>
                    <div className={styles.label}>{opcao.label}</div>
                </button>
            ))}
        </div>
    );
}